/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmProjectIntegrationData } from './CrmProjectIntegrationData';
import {
    CrmProjectIntegrationDataFromJSON,
    CrmProjectIntegrationDataFromJSONTyped,
    CrmProjectIntegrationDataToJSON,
    CrmProjectIntegrationDataToJSONTyped,
} from './CrmProjectIntegrationData';
import type { CrmProjectContactData } from './CrmProjectContactData';
import {
    CrmProjectContactDataFromJSON,
    CrmProjectContactDataFromJSONTyped,
    CrmProjectContactDataToJSON,
    CrmProjectContactDataToJSONTyped,
} from './CrmProjectContactData';
import type { CrmProjectSubscriptionData } from './CrmProjectSubscriptionData';
import {
    CrmProjectSubscriptionDataFromJSON,
    CrmProjectSubscriptionDataFromJSONTyped,
    CrmProjectSubscriptionDataToJSON,
    CrmProjectSubscriptionDataToJSONTyped,
} from './CrmProjectSubscriptionData';
import type { CrmProjectBillingData } from './CrmProjectBillingData';
import {
    CrmProjectBillingDataFromJSON,
    CrmProjectBillingDataFromJSONTyped,
    CrmProjectBillingDataToJSON,
    CrmProjectBillingDataToJSONTyped,
} from './CrmProjectBillingData';

/**
 * 
 * @export
 * @interface CrmProjectSnapshotData
 */
export interface CrmProjectSnapshotData {
    /**
     * 
     * @type {number}
     * @memberof CrmProjectSnapshotData
     */
    schemaVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSnapshotData
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSnapshotData
     */
    currency?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectSnapshotData
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSnapshotData
     */
    primaryContactUserId?: string | null;
    /**
     * 
     * @type {CrmProjectSnapshotDataPrimaryContactOriginEnum}
     * @memberof CrmProjectSnapshotData
     */
    primaryContactOrigin?: CrmProjectSnapshotDataPrimaryContactOriginEnum;
    /**
     * 
     * @type {CrmProjectBillingData}
     * @memberof CrmProjectSnapshotData
     */
    billing?: CrmProjectBillingData | null;
    /**
     * 
     * @type {Array<CrmProjectContactData>}
     * @memberof CrmProjectSnapshotData
     */
    contacts?: Array<CrmProjectContactData>;
    /**
     * 
     * @type {Array<CrmProjectIntegrationData>}
     * @memberof CrmProjectSnapshotData
     */
    integrations?: Array<CrmProjectIntegrationData>;
    /**
     * 
     * @type {CrmProjectSubscriptionData}
     * @memberof CrmProjectSnapshotData
     */
    subscription?: CrmProjectSubscriptionData | null;
}


/**
 * @export
 */
export const CrmProjectSnapshotDataPrimaryContactOriginEnum = {
    Observed: 'observed',
    LegacyInferred: 'legacy_inferred',
    Manual: 'manual',
    Unknown: 'unknown'
} as const;
export type CrmProjectSnapshotDataPrimaryContactOriginEnum = typeof CrmProjectSnapshotDataPrimaryContactOriginEnum[keyof typeof CrmProjectSnapshotDataPrimaryContactOriginEnum];


/**
 * Check if a given object implements the CrmProjectSnapshotData interface.
 */
export function instanceOfCrmProjectSnapshotData(value: object): value is CrmProjectSnapshotData {
    return true;
}

export function CrmProjectSnapshotDataFromJSON(json: any): CrmProjectSnapshotData {
    return CrmProjectSnapshotDataFromJSONTyped(json, false);
}

export function CrmProjectSnapshotDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectSnapshotData {
    if (json == null) {
        return json;
    }
    return {
        
        'schemaVersion': json['schemaVersion'] == null ? undefined : json['schemaVersion'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'currency': json['currency'] === undefined ? undefined : json['currency'] === null ? null : json['currency'],
        'createdAt': json['createdAt'] === undefined ? undefined : json['createdAt'] === null ? null : (new Date(json['createdAt'])),
        'primaryContactUserId': json['primaryContactUserId'] === undefined ? undefined : json['primaryContactUserId'] === null ? null : json['primaryContactUserId'],
        'primaryContactOrigin': json['primaryContactOrigin'] == null ? undefined : json['primaryContactOrigin'],
        'billing': json['billing'] === undefined ? undefined : json['billing'] === null ? null : CrmProjectBillingDataFromJSON(json['billing']),
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(CrmProjectContactDataFromJSON)),
        'integrations': json['integrations'] == null ? undefined : ((json['integrations'] as Array<any>).map(CrmProjectIntegrationDataFromJSON)),
        'subscription': json['subscription'] === undefined ? undefined : json['subscription'] === null ? null : CrmProjectSubscriptionDataFromJSON(json['subscription']),
    };
}

export function CrmProjectSnapshotDataToJSON(json: any): CrmProjectSnapshotData {
    return CrmProjectSnapshotDataToJSONTyped(json, false);
}

export function CrmProjectSnapshotDataToJSONTyped(value?: CrmProjectSnapshotData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'schemaVersion': value['schemaVersion'],
        'name': value['name'],
        'currency': value['currency'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'primaryContactUserId': value['primaryContactUserId'],
        'primaryContactOrigin': value['primaryContactOrigin'],
        'billing': CrmProjectBillingDataToJSON(value['billing']),
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(CrmProjectContactDataToJSON)),
        'integrations': value['integrations'] == null ? undefined : ((value['integrations'] as Array<any>).map(CrmProjectIntegrationDataToJSON)),
        'subscription': CrmProjectSubscriptionDataToJSON(value['subscription']),
    };
}

